import request from '@/utils/request'

// 查询【客户联系人】列表
export function listSale(query) {
  return request({
    url: '/scrm/sale/list',
    method: 'get',
    params: query
  })
}

// 查询【客户联系人】详细
export function getSale(custSaleId) {
  return request({
    url: '/scrm/sale/' + custSaleId,
    method: 'get'
  })
}

// 新增【客户联系人】
export function addSale(data) {
  return request({
    url: '/scrm/sale',
    method: 'post',
    data: data
  })
}

// 修改【客户联系人】
export function updateSale(data) {
  return request({
    url: '/scrm/sale',
    method: 'put',
    data: data
  })
}

// 删除【客户联系人】
export function delSale(custSaleId) {
  return request({
    url: '/scrm/sale/' + custSaleId,
    method: 'delete'
  })
}

// 导出【客户联系人】
export function exportSale(query) {
  return request({
    url: '/scrm/sale/export',
    method: 'get',
    params: query
  })
}